/**
 * Generated runtime TestId mirror for frontend/src/components/attributes/PatternSuggestDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const PatternSuggestDialogTestIds = {
  patternAddSample: "pattern-add-sample",
  patternColActions: "pattern-col-actions",
  patternColIndex: "pattern-col-index",
  patternColValue: "pattern-col-value",
  patternEmptyState: "pattern-empty-state",
  patternInferred: "pattern-inferred",
  patternSampleInput: "pattern-sample-input",
  patternSamplesBody: "pattern-samples-body",
  patternSuggestAccept: "pattern-suggest-accept",
  patternSuggestCancel: "pattern-suggest-cancel",
  patternSuggestClear: "pattern-suggest-clear",
  patternSuggestTitle: "pattern-suggest-title",
  patternRemoveSample: (index: number) => `pattern-remove-sample-${index}`,
  patternRemoveSamplePrefix: () => "pattern-remove-sample-" as TestIdPrefix,
  patternSampleRow: (index: number) => `pattern-sample-row-${index}`,
  patternSampleRowPrefix: () => "pattern-sample-row-" as TestIdPrefix
} as const;
